export default __webpack_public_path__ + "static/media/btn-reime.1b4bb8e8.webp";